@if (!!t4Summary.id) {
    <ui-card>
        <app-segment-header title="payroll.taxReturns.t4SummaryDetails" />
        <div class="flex col">
            <app-tax-return-summary-details-row
                label="payroll.taxReturns.lines.employmentIncome"
                [amount]="t4Summary.totEmptIncamt"
            />
            <app-tax-return-summary-details-row
                label="payroll.taxReturns.lines.employeesCppContributions"
                [amount]="t4Summary.totEmpeCppAmt"
            />
            <app-tax-return-summary-details-row
                label="payroll.taxReturns.lines.employeesCpp2Contributions"
                [amount]="t4Summary.totEmpeCppeAmt"
            />
            <app-tax-return-summary-details-row
                label="payroll.taxReturns.lines.employeesEiPremiums"
                [amount]="t4Summary.totEmpeEipAmt"
            />
            <app-tax-return-summary-details-row
                label="payroll.taxReturns.lines.employersEiPremiums"
                [amount]="t4Summary.totEmprEipAmt"
            />
            <app-tax-return-summary-details-row
                label="payroll.taxReturns.lines.registeredPensionPlanRppContributions"
                [amount]="t4Summary.totRppCntrbAmt"
            />
            <app-tax-return-summary-details-row
                label="payroll.taxReturns.lines.incomeTaxDeducted"
                [amount]="t4Summary.totItxDdctAmt"
            />
            <app-tax-return-summary-details-row
                label="payroll.taxReturns.lines.employersCppContributions"
                [amount]="t4Summary.totEmprCppAmt"
            />
            <app-tax-return-summary-details-row
                label="payroll.taxReturns.lines.employersCpp2Contributions"
                [amount]="t4Summary.totEmprCppeAmt"
            />
            <app-tax-return-summary-details-row
                label="payroll.taxReturns.lines.pensionAdjustment"
                [amount]="t4Summary.totPadjAmt"
            />
        </div>
    </ui-card>
}
